import { motion } from "framer-motion";
import { RevealText, FadeIn } from "../motion/Reveal";
import { SectionLabel } from "../motion/SectionLabel";
import { ORIGINALS } from "../../data/content";

export const Originals = () => {
  return (
    <section
      id="originals"
      data-testid="originals-section"
      className="relative min-h-screen flex flex-col justify-center py-28 md:py-32 px-6 md:px-10 bg-[#0a0a0a]"
    >
      <div className="max-w-[1400px] mx-auto">
        <SectionLabel>{ORIGINALS.label}</SectionLabel>

        <RevealText
          as="h2"
          lines={["Original stories.", "Built to scale."]}
          className="mt-6 font-display font-bold text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.98] tracking-tight"
        />

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6 space-y-6">
            {ORIGINALS.paragraphs.map((p, i) => (
              <FadeIn key={i} delay={i * 0.08}>
                <p
                  className={`font-body leading-relaxed font-light ${
                    i === 0 ? "text-white text-xl md:text-2xl" : "text-neutral-400 text-lg"
                  }`}
                >
                  {p}
                </p>
              </FadeIn>
            ))}
          </div>
        </div>

        {/* Recent releases image trio */}
        <FadeIn delay={0.08}>
          <h3
            data-testid="originals-recent-releases-heading"
            className="mt-16 font-display font-bold text-white text-3xl md:text-5xl leading-[1.05] tracking-tight"
          >
            Our Recent Releases
          </h3>
        </FadeIn>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          {ORIGINALS.images.map((src, i) => (
            <FadeIn
              key={i}
              delay={i * 0.1}
              className="group relative overflow-hidden rounded-2xl border border-white/10 aspect-[4/5]"
              data-testid={`originals-image-${i}`}
            >
              <motion.img
                src={src}
                alt=""
                aria-hidden
                data-testid={`originals-release-image-${i + 1}`}
                className="h-full w-full object-cover grayscale-[0.35] transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
            </FadeIn>
          ))}
        </div>

        {/* Genres + focus */}
        <div className="mt-20 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-6">
            <FadeIn>
              <p className="font-body text-lg text-neutral-400 leading-relaxed font-light">
                {ORIGINALS.genreIntro}
              </p>
            </FadeIn>
            <div className="mt-6 flex flex-wrap gap-3">
              {ORIGINALS.genres.map((g, i) => (
                <FadeIn key={g} delay={i * 0.06}>
                  <span
                    data-testid={`originals-genre-${i}`}
                    className="inline-block rounded-full border border-white/15 bg-white/[0.03] px-5 py-2.5 font-body text-sm text-neutral-200 hover:border-[#ff4500]/50 hover:text-white transition-colors duration-300"
                  >
                    {g}
                  </span>
                </FadeIn>
              ))}
            </div>
          </div>

          <FadeIn delay={0.1} className="lg:col-span-6">
            <p className="font-display font-bold text-white text-3xl md:text-5xl leading-[1.05] tracking-tight">
              <span className="text-gradient-warm">{ORIGINALS.focus}</span>
            </p>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
